import App from './app.svelte';
// import * as rpcjs from 'rpcjs';

const app = new App({
    target: document.body,
});

export default app;
